import { render, staticRenderFns } from "./VideoEditTest2.vue?vue&type=template&id=00a460b9&scoped=true&"
import script from "./VideoEditTest2.vue?vue&type=script&lang=js&"
export * from "./VideoEditTest2.vue?vue&type=script&lang=js&"
import style0 from "./VideoEditTest2.vue?vue&type=style&index=0&id=00a460b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a460b9",
  null
  
)

export default component.exports